<template>
  <div aria-hidden="true" aria-labelledby="modalFillInLabel" role="dialog" tabindex="-1" class="modal modal-default modal-delete in" id="modal-chat-template-delete" style="display:block;">
    <div class="modal-dialog">
      <div class="modal-content">
        <header class="modal-header">
          <strong>{{ __('Delete template') }}</strong>
          <p>{{ __('Do you really want to delete this template?') }}</p>
        </header>

        <div class="modal-body">
          <div class="btn-group">
            <VButton :label="__('Cancel')" @onClick="$emit('mode', 'list')" variant="secondary" />
            <VButton :label="__('Delete')" @onClick="remove()" type="submit" color="danger" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    template: {
      type: Object,
      required: false
    }
  },
  methods: {
    ...mapActions({
      deleteTemplate: 'chat-templates/deleteTemplate'
    }),
    remove() {
      this.deleteTemplate(this.template)
      this.$emit('mode', 'list')
      Vuemit.fire('Button--sending-failed', true)
    }
  }
}
</script>
